<template>
  <div >
    <v-card flat v-if="items != []">
        <v-container class="pt-2" >
            <v-card-title class="text-center justify-center py-6">
                <h1 class="font-weight-bold display-2 customGrey--text">
                    PORTFOLIO
                </h1>
            </v-card-title>
            <v-tabs
                v-model="tab"
                background-color="transparent"
                :color="globalColorC"
                grow
            >
                <v-tab
                v-for="(item,index) in items.itemTitle"
                :key="index"
                >
                {{ item }}
                </v-tab>
            </v-tabs>

            <v-divider></v-divider>
        
            <v-tabs-items v-model="tab" >
                <v-tab-item
                v-for="(item,index) in items.itemTitle"
                :key="index"
                >
                    <v-card
                        flat
                    >
                        <v-container fill-height fluid class="pa-2"  >
                            <v-row >
                                <v-col cols="auto" sm="12" lg="4"
                                    v-for="(item,index) in items.itemDetails[tab]"
                                    :key="index"
                                    right
                                >
                                    <v-hover v-slot="{ hover }">
                                        <v-card 
                                            @click="item.jobViewMore ? viewMoreOpen(item) : ''"
                                            :color="hover ? globalColorC : globalColorA" class="pa-4 text-left" raised shaped min-height="750" >
                                            <div class="pt-1 pb-2 d-flex flex-column justify-space-between align-center">
                                                <v-img
                                                    v-if="item.jobImage != ''"
                                                    height="125"
                                                    width="125"
                                                    :src="require('../assets/jobImage/' + item.jobImage)"
                                                    transition="slide-x-transition"
                                                ></v-img>
                                            </div>
                                            <h2 
                                                :class="hover ? `headline font-weight-bold display-1 salmonOrange--text` : 'headline font-weight-bold display-1 customGrey--text'">
                                                {{item.jobName}}
                                            </h2>
                                            <span
                                                :class="hover ? `title font-weight-light display-1 salmonOrange--text` : 'title font-weight-light display-1 customGrey--text'"
                                                v-text="item.jobDate"
                                            ></span>
                                            <h2 :class="hover ? `title font-weight-medium display-1 salmonOrange--text` : 'title font-weight-medium display-1 customGrey--text'">
                                                {{item.jobTitle}}
                                            </h2>
                                            <div class="pt-2">
                                                <p :class="hover ? `title font-weight-bold display-1 salmonOrange--text` : 'title font-weight-bold display-1 customGrey--text'">
                                                    {{item.jobDescription}}
                                                </p>
                                            </div>

                                            <v-divider></v-divider>
                                            
                                            <div class="pt-2" v-if="item.jobTechnical.frontEnd.length != 0">
                                                <p :class="hover ? `subtitle-1 font-weight-bold display-1 salmonOrange--text` : 'subtitle-1 font-weight-bold display-1 customGrey--text'">
                                                    {{item.jobTechnical.frontEndText}}
                                                </p>
                                                <div v-for="(skill,index) in item.jobTechnical.frontEnd" :key="index">
                                                    <p :class="hover ? `subtitle-1 font-weight-medium display-1 salmonOrange--text` : 'subtitle-1 font-weight-medium display-1 customGrey--text'">
                                                        {{index + 1 }} : {{skill}}
                                                    </p>
                                                </div>
                                            </div>

                                            <div class="pt-2" v-if="item.jobTechnical.backEnd.length != 0">
                                                <p :class="hover ? `subtitle-1 font-weight-bold display-1 salmonOrange--text` : 'subtitle-1 font-weight-bold display-1 customGrey--text'">
                                                    {{item.jobTechnical.backEndText}}
                                                </p>
                                                    <div v-for="(skill,index) in item.jobTechnical.backEnd" :key="index">
                                                        <p :class="hover ? `subtitle-1 font-weight-medium salmonOrange--text` : 'subtitle-1 font-weight-medium customGrey--text'">
                                                            {{index + 1 }} : {{skill}}
                                                        </p>
                                                    </div>
                                            </div>

                                            <div class="pt-2" v-if="item.jobProject.length != 0">
                                                <v-divider></v-divider>

                                                <p :class="hover ? `subtitle-1 font-weight-bold salmonOrange--text` : 'subtitle-1 font-weight-bold customGrey--text'">
                                                    {{item.jobProjectText}}
                                                </p>

                                                <div v-for="(project,index) in item.jobProject" :key="index">
                                                    <p 
                                                        @click="openProjectLink(project)"
                                                        :class="hover ? `subtitle-1 font-weight-medium salmonOrange--text text-decoration-underline` : 'subtitle-1 font-weight-medium  customGrey--text text-decoration-underline'">
                                                        {{project}}
                                                    </p>
                                                </div>

                                            </div>

                                            <!-- <v-btn :color="globalColorB" width="180" v-if="item.jobViewMore" @click="viewMoreOpen(item)">
                                                <v-icon >mdi-dots-horizontal-circle-outline</v-icon>
                                                <span :class="'font-weight-bold text-center title pa-2 customGrey--text'">{{globalLanguage.portfolioViewMore}}</span>
                                            </v-btn> -->
                                        </v-card>
                                    </v-hover>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-container>
    </v-card>

    <v-dialog
        class="z-index:100"
        v-if="viewMore"
        v-model="viewMore"
        persistent
        width="1200"
      >
      <v-card >
        <v-toolbar
         
          dark
          :color="globalColorC"
        >
          <v-btn
            icon
            dark
            @click="viewMore = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-img max-width="40" :src="require('../assets/jobImage/' + selectedItem.jobImage)"></v-img>
          <v-toolbar-title :class="'font-weight-medium title pa-3 salmonOrange--text'">{{selectedItem.jobName}}</v-toolbar-title>
        </v-toolbar>

        <v-carousel 
            class="pa-2"
            height="auto"
            :show-arrows="false"
            >
            <v-carousel-item
                v-for="(item,i) in selectedItem.jobScreenShot"
                :key="i"
            >
                <v-img 
                    :src="imageCarousel(item)"
                    :lazy-src="require('../assets/jobImage/jobScreenShot/lazy.jpg')"
                    >
                </v-img>
            </v-carousel-item>
        </v-carousel> 

        <v-card-text>
            <p class="font-weight-bold title customGrey--text ">{{globalLanguage.portfolioExplanation}}</p>
            <div
                v-for="(item,i) in selectedItem.jobExplanation"
                :key="i"
            >
                <span class="font-weight-light text-justify subtitle-1 customGrey--text">{{item}}</span>
            </div>
            
        </v-card-text>

        <!-- <v-card-text>
            <span class="font-weight-bold title customGrey--text pa-1">{{globalLanguage.portfolioScreenShot}}</span>
        </v-card-text> -->

       
        
      </v-card>
    </v-dialog>
    
  </div>
  
</template>

<script>

import PORTFOLIOBM from "../languageJSON/portfolioBm.json"
import PORTFOLIOENG from "../languageJSON/portfolioEng.json"

export default {
  name: 'Portfolio',
  props: ['globalColorA','globalColorB',"globalColorC","globalLanguage"],
  data () {
    return {
      tab: 1,
      items: [],
      viewMore : false,
      selectedItem : {},
      items3:[
          "Colla_Tale_1.jpg" , "Colla_Tale_2.jpg"
      ]
    }
  },

  watch:{

      globalLanguage()
      {
        this.addPortfolio()
      }
  },

  mounted()
  {
    window.scrollTo(0, 0)
    this.addPortfolio()
  },

  methods: 
  {
    addPortfolio()
    {
        if(this.globalLanguage.selectedLanguage == "eng")
        {
            this.items = PORTFOLIOENG
        }
        else if(this.globalLanguage.selectedLanguage == "bm")
        {
            this.items = PORTFOLIOBM
        }
        
    },

    timelineClass(index)
    {
        if(index % 2 == 0)
        {
            return "text-left"
        }
        else
        {
            return "text-right"
        }
    },

    viewMoreOpen(item)
    {
        this.selectedItem = item
        this.viewMore = true
    },

    imageCarousel(urlImage)
    {
        var url = require("../assets/jobImage/jobScreenShot/" + urlImage)

        return url
    },

    openProjectLink(linkUrl)
    {
        window.open(linkUrl);
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/Portfolio.vue